export default __webpack_public_path__ + "static/media/home1.930d9e6f.png";